import {
    URL_DASHBOARD,
    URL_FAQ,
    URL_NEWS_MANAGER,
    URL_OFFERS,
    URL_OFFERS_MANAGER,
    URL_PARTNERS,
    URL_PAYMENTS,
    URL_PAYMENTS_MANAGER,
    URL_PROJECTS,
    URL_REFERRAL,
    URL_STATISTIC,
    URL_TOOLS,
} from "../../../properties";
import dashboardImg from "../../../resources/images/app/navigation/dashboard.png";
import faqImg from "../../../resources/images/app/navigation/faq.png";
import offersImg from "../../../resources/images/app/navigation/offers.png";
import projectsImg from "../../../resources/images/app/navigation/potok.png";
import walletImg from "../../../resources/images/app/header/wallet.png";
import referalsImg from "../../../resources/images/app/navigation/rabs.png";
import analysisImg from "../../../resources/images/app/navigation/anal.png";
import toolsImg from "../../../resources/images/app/navigation/instruments.png";
import newsImg from "../../../resources/images/app/navigation/news.png";

export const getBasePageLinksData = (auth, partnerId) => {
    const {isAdminAsPartner, isAuthenticated, isPartner, isSeniorArbitr, isArbitr} = auth;
    const params = isAdminAsPartner ? `?partnerId=${partnerId}` : "";
    const links = [];

    if (isAuthenticated) {
        if (isPartner || isAdminAsPartner) {
            links.push({key: 1, hideOnMobile: false, name: 'Дашборд', href: URL_DASHBOARD + params, pathName: URL_DASHBOARD, img: dashboardImg});
            links.push({key: 3, hideOnMobile: false, name: 'Офферы', href: URL_OFFERS + params, pathName: URL_OFFERS, img: offersImg});
            links.push({key: 4, hideOnMobile: false, name: 'Потоки', href: URL_PROJECTS + params, pathName: URL_PROJECTS, img: projectsImg});
            links.push({key: 7, hideOnMobile: false, name: 'Финансы', href: URL_PAYMENTS + params, pathName: URL_PAYMENTS, img: walletImg});
            links.push({key: 8, hideOnMobile: false, name: 'Рефералы', href: URL_REFERRAL + params, pathName: URL_REFERRAL, img: referalsImg});
        }

        links.push({key: 2, hideOnMobile: false, name: 'Аналитика', href: URL_STATISTIC + params, pathName: URL_STATISTIC, img: analysisImg});

        if (!isSeniorArbitr && !isArbitr) {
            links.push({key: 9, hideOnMobile: false, name: 'Инструменты', href: URL_TOOLS + params, pathName: URL_TOOLS, img: toolsImg});
            links.push({key: 10, hideOnMobile: false, name: 'FAQ', href: URL_FAQ + params, pathName: URL_FAQ, img: faqImg});
        }

        if (!isPartner && !isAdminAsPartner && !isArbitr) {
            links.push({key: 5, hideOnMobile: false, name: 'Партнёры', href: URL_PARTNERS, pathName: URL_PARTNERS, img: referalsImg});

            if (!isSeniorArbitr) {
                links.push({key: 3, hideOnMobile: false, name: 'Офферы', href: URL_OFFERS_MANAGER, pathName: URL_OFFERS_MANAGER, img: offersImg});
                links.push({key: 6, hideOnMobile: false, name: 'Уведомления', href: URL_NEWS_MANAGER, pathName: URL_NEWS_MANAGER, img: newsImg});
                links.push({key: 7, hideOnMobile: false, name: 'Финансы', href: URL_PAYMENTS_MANAGER, pathName: URL_PAYMENTS_MANAGER, img: walletImg});
            }
        }
    }

    links.sort((a1, a2) => a1.key - a2.key);
    return links;
};
